import WithRender from "../../templates/base/packingOptions.html";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { i18n } from "../../i18n.js";
import { validateInput } from "../../helpers/helpers";

function fnDebounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

export default WithRender({
  computed: {
    ...mapGetters(["getPackingOptions", "getLimits"]),
    name: function () {
      return i18n.t("pv_" + this.propsData.label);
    },
    option() {
      return this.propsData.value;
    }
  },
  methods: {
    ...mapActions(["setPackingOption", "packingGetData"]),
    ...mapMutations(["setAppliedCustomFormat"]),
    updateOption(event) {
      var newValue = event.target.value;
      var attribute = this.propsData.code.replace("packing_format_", "");
      var min = null;
      var max = null;
      if (this.getLimits[attribute]) {
        min = this.getLimits[attribute].min;
        max = this.getLimits[attribute].max;
      }
      var optionValid = validateInput(newValue, this.propsData.label, min, max);
      if (!optionValid.valid) {
        this.$swal({ text: optionValid.msg, icon: "warning" });
        this.setPackingOption({
          code: this.propsData.code,
          value: this.propsData.value
        });
        this.setAppliedCustomFormat(false);
        return;
      }
      this.setPackingOption({
        code: this.propsData.code,
        value: newValue
      });
      this.packingGetData({ callChangeOptions: true });
    },
    updateOptionDebounce: fnDebounce(function (event) {
      this.updateOption(event);
    }, 500),
    updateOptionAddFlag: function (event) {
      this.setAppliedCustomFormat(true);
      this.updateOptionDebounce(event);
    }
  },
  props: ["propsData"]
});
